import employmentTypesService from '@/services/employmentTypes.service'

export default {
  namespaced: true,
  state: {
    employmentTypes: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_EMPLOYMENT_TYPES(state, employmentTypes) {
      state.employmentTypes = employmentTypes
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_EMPLOYMENT_TYPE(state, employmentType) {
      state.employmentTypes.push(employmentType)
    },
    UPDATE_EMPLOYMENT_TYPE(state, updatedEmploymentType) {
      const index = state.employmentTypes.findIndex(e => e.id === updatedEmploymentType.id)
      if (index !== -1) {
        state.employmentTypes.splice(index, 1, updatedEmploymentType)
      }
    },
    REMOVE_EMPLOYMENT_TYPE(state, id) {
      state.employmentTypes = state.employmentTypes.filter(e => e.id !== id)
    }
  },
  actions: {
    async fetchEmploymentTypes({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employmentTypesService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const employmentTypes = response.data?.data || response.data || []
        commit('SET_EMPLOYMENT_TYPES', employmentTypes)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createEmploymentType({ commit }, employmentTypeData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employmentTypesService.create(employmentTypeData)
        if (response.success) {
          commit('ADD_EMPLOYMENT_TYPE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateEmploymentType({ commit }, { id, employmentTypeData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employmentTypesService.update(id, employmentTypeData)
        if (response.success) {
          commit('UPDATE_EMPLOYMENT_TYPE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteEmploymentType({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employmentTypesService.delete(id)
        if (response.success) {
          commit('REMOVE_EMPLOYMENT_TYPE', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allEmploymentTypes: state => state.employmentTypes,
    activeEmploymentTypes: state => state.employmentTypes.filter(e => e.active),
    isLoading: state => state.loading
  }
}

